export var NAVIGATION_CLASS_PREFIX = 'Navigation';
export var DEFAULT_MAX_DEPTH_LEVEL = 3;